/**
 * 员工派单数量
 */

import request from '@/utils/axios'
import { ContentTypeEnum } from '@/enums/axios'
const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}
// 获取员工派单数量
export const getStaffAssignNumConfigApi = (data?: any) =>
  request.post('/crm-report/staffAssignSwitchConfig/staffCount', data, jsonHeaderConfig)
